import React,{useEffect,useState} from 'react'
import { connect } from 'react-redux';
import { Link,useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import Loading_Scren from '../Front/LoadingScreen';
import axios from 'axios'
import * as ApiUrls from '../../Constants/ApiUrls';
import { context, propagation, trace } from '@opentelemetry/api';
import { W3CTraceContextPropagator } from '@opentelemetry/core'



const My_Profile = ({token}) => {

  const containerStyle = {
    width: '100%', // Set the width to 100% for full-width
  };


 
  const [loadingData , setLoadingData] = useState(false);
  const [userDetails,setUserDetails] = useState();
  const navigate = useNavigate()

  // Detail
  // Firstname
  const [firstname , setFirstname] = useState('');
  // Lastname
  const [lastname , setLastname] = useState('');
  // username
  const [username , setUsername] = useState('');
  // email
  const [email , setEmail] = useState('');
  // dateOfBirth
  const [dob , setDOB] = useState('');
  // number
  const [number , setNumber] = useState();
  // address
  const [address , setAddress] = useState([]);




  useEffect(()=>{
    getUserDetails()
  },[])


  // useEffect(() => {
  //   const tracer = trace.getTracer('component-tracer');
  //   const span = tracer.startSpan('USER_PROFILE');
  //   return () => {
  //     span.end();
  //   };
  // }, []);


  const getUserDetails=async()=>{
    
    setLoadingData(true);
    var accessToken = token.access;
    propagation.setGlobalPropagator(new W3CTraceContextPropagator());
    const tracer = trace.getTracer('api-tracer');
    const span = tracer.startSpan('USER_PROFILE');
    //console.log(accessToken)

    try {


      const activeContext = context.active();
      const spanWithContext = trace.setSpan(activeContext, span);
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      };
      propagation.inject(spanWithContext, headers);


      await axios.get(`${ApiUrls.GET_USER_PROFILE_DETAILS_URL}`,{ headers }).then(res=>{

        const data = res.data.details["User-Details"]

        setUserDetails(res.data.details["User-Details"])
        setFirstname(data.firstname)
        setLastname(data.lastname)
        setUsername(data.username)
        setEmail(data.email)
        setDOB(data.dateOfBirth)
        setNumber(data.number)
        setAddress(data.address)

       //console.log(res.data.details["User-Details"].firstname)
      setLoadingData(false);
      span.end();
      }).catch(err=>{
       console.log(err)
       setLoadingData(false);
       Swal.fire({
        title: "Oops?",
        text: "Something went wrong",
        icon: "error"
      });
      })
      span.end();
    } catch (error) {
      console.log(error)
     setLoadingData(false);
     Swal.fire({
      title: "Oops?",
      text: "Something went wrong",
      icon: "error"
    });
    span.end();
    }



  }



  const logout = ()=>{
    Swal.fire({
      title: "Are you sure?",
      showCancelButton: true,
      confirmButtonColor: "#000",
      cancelButtonColor: "#22C9B7",
      confirmButtonText: "Yes, Log me out"
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.clear()

        navigate('/login')
      }
    });
      
  }
  

  return (



    <>
  {loadingData && <Loading_Scren />} 

    <div className='dashboard-section-ui container px-4'style={containerStyle}>


        <div className="container px-4">
        <h1 className='saving-account'>Personal Details</h1>
        <div className='edit-block'>
          <div className="row">
            <div className="col">
                <lable className='lab-name'>First name</lable><br></br>
                <input className='input-box-des'type='text'placeholder='First name' defaultValue={firstname}/>
            </div>
            <div className="col">
            <lable className='lab-name'>Last name</lable><br></br>
                <input className='input-box-des'type='text' placeholder='Last name'defaultValue={lastname}  />
            </div>
            
          </div>
<br></br>
<br></br>
          <div className="row">
            <div className="col">
                <lable className='lab-name'>Email</lable><br></br>
                <input className='input-box-des'type='text'placeholder='liam_patel@bmc.com' defaultValue={email}/>
            </div>
            <div className="col">
            <lable className='lab-name'>Date of Birth</lable><br></br>
                <input className='input-box-des'type='text' placeholder='4-12-2000' defaultValue={dob}/>
            </div>
          

          </div>


          <br></br>
<br></br>
          <div className="row">
            <div className="col">
                <lable className='lab-name'>Phone number</lable><br></br>
                <input className='input-box-des'type='text'placeholder='+91 1234567891' defaultValue={number}/>
            </div>
            <div className="col">
            <lable className='lab-name'>Address</lable><br></br>
                <textarea className='input-box-des'type='text' defaultValue={`${address.street}, ${address.city}, ${address.state}, ${address.postal}, ${address.country}`} placeholder='Pune'/>
            </div>
            
          </div>
          <br></br>
<br></br>
          <button className='login-btn-hero'>Edit Info</button>
        </div>

<br></br>
<br></br>

        <div className='edit-block-two'>
          
          <div className="row">
            <div className="col">
                <lable className='lab-name'>Username</lable><br></br>
                <input className='input-box-des'type='text'placeholder='Username'defaultValue={username}/>
            </div>
            <div className="col">
            <lable className='lab-name'>Password</lable><br></br>
                <input className='input-box-des'type='text' placeholder='Password'defaultValue="12345"/>
            </div>
            
          </div>

        <br></br>
          <button className='login-btn-hero'>Edit Info</button>

          <button className='login-btn-hero-logout'onClick={()=>logout()}>Logout</button>
        </div>

        </div>

        <br></br>


       
        
      </div>

    
    </>
  )
}


const mapStateToProps = (state) => {
  return {
    token: state.account.token,
    isLoading: state.account.isLoading,
    currentUser:state.account.currentUser
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(My_Profile)